import { render } from "./FullscreenButton.vue?vue&type=template&id=09e4fe5a&scoped=true"
import script from "./FullscreenButton.vue?vue&type=script&lang=js"
export * from "./FullscreenButton.vue?vue&type=script&lang=js"

import "./FullscreenButton.vue?vue&type=style&index=0&id=09e4fe5a&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e4fe5a"]])

export default __exports__